namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.UnBlockedSMSCustomersGrid')
    export class UnBlockedSMSCustomersGrid extends Serenity.EntityGrid<UnBlockedSMSCustomersRow, any> {
        protected getColumnsKey() { return UnBlockedSMSCustomersColumns.columnsKey; }
        protected getDialogType() { return UnBlockedSMSCustomersDialog; }
        protected getIdProperty() { return UnBlockedSMSCustomersRow.idProperty; }
        protected getInsertPermission() { return UnBlockedSMSCustomersRow.insertPermission; }
        protected getLocalTextPrefix() { return UnBlockedSMSCustomersRow.localTextPrefix; }
        protected getService() { return UnBlockedSMSCustomersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel', grid: this, service: UnBlockedSMSCustomersService.baseUrl + '/ListExcel', onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }

         protected getColumns() {
    var columns = super.getColumns();

    columns.push({
        field: 'Id',
        name: '',
        width: 200,
        format: ctx => {
            return `
                <form action="/UnBlockedSMSCustomers/UnBlockNumber/" method="get" onsubmit="return confirm('Are you sure you want to unblock this number?')">
                    <div class="d-flex align-items-center gap-2 me-5">
                        <input class="d-none" name="id" value="${ctx.value}" type="text">
                        <button class="text-danger p-0 btn fw-bold" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Unblock Number">
                            Unblock
                        </button>
                    </div>
                </form>`;
        }
    });

    return columns;
}


    }
}